import { HttpApiClient } from "./http";
import { MockApiClient } from "./mock";

export function createApiClient(tenantId) {
  if (import.meta.env.VITE_USE_MOCK_API === "1") {
    return new MockApiClient(tenantId);
  }
  return new HttpApiClient(tenantId);
}

export { ApiError } from "./client";
